import { Injectable } from '@angular/core';

export interface ICoordsTable {
    rowIndex: number;
    colIndex: number;
}

@Injectable()
export class TableKeyboardNavigationService {
    public moveLeft(focusCoords: ICoordsTable, colMax: number): ICoordsTable {
        if (focusCoords.rowIndex === 0 && focusCoords.colIndex === 0) {
            return focusCoords;
        } else if (focusCoords.colIndex === 0) {
            return {
                rowIndex: focusCoords.rowIndex - 1,
                colIndex: colMax,
            };
        }
        return {
            rowIndex: focusCoords.rowIndex,
            colIndex: focusCoords.colIndex - 1,
        };
    }

    public moveRight(focusCoords: ICoordsTable, rowMax: number, colMax: number): ICoordsTable {
        if (focusCoords.rowIndex === rowMax && focusCoords.colIndex === colMax) {
            return focusCoords;
        } else if (focusCoords.colIndex === colMax) {
            return {
                rowIndex: focusCoords.rowIndex + 1,
                colIndex: 0,
            };
        }
        return {
            rowIndex: focusCoords.rowIndex,
            colIndex: focusCoords.colIndex + 1,
        };
    }

    public moveUp(focusCoords: ICoordsTable): ICoordsTable {
        if (focusCoords.rowIndex === 0) {
            return focusCoords;
        }
        return {
            rowIndex: focusCoords.rowIndex - 1,
            colIndex: focusCoords.colIndex,
        };
    }

    public moveDown(focusCoords: ICoordsTable, rowMax: number): ICoordsTable {
        if (focusCoords.rowIndex === rowMax) {
            return focusCoords;
        }
        return {
            rowIndex: focusCoords.rowIndex + 1,
            colIndex: focusCoords.colIndex,
        };
    }

    public moveNextLine(focusCoords: ICoordsTable, rowMax: number, colMax: number): ICoordsTable {
        if (focusCoords.rowIndex === rowMax && focusCoords.colIndex === colMax) {
            return focusCoords;
        } else if (focusCoords.rowIndex === rowMax) {
            return {
                rowIndex: focusCoords.rowIndex,
                colIndex: focusCoords.colIndex + 1,
            };
        }
        return {
            rowIndex: focusCoords.rowIndex + 1,
            colIndex: focusCoords.colIndex,
        };
    }
}